import { render, staticRenderFns } from "./compIntro.vue?vue&type=template&id=0b330cce"
import script from "./compIntro.vue?vue&type=script&lang=js"
export * from "./compIntro.vue?vue&type=script&lang=js"
import style0 from "./compIntro.vue?vue&type=style&index=0&id=0b330cce&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports